import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Login = () => {
  const nav = useNavigate();
  const [form, setForm] = useState({ emailOrUsername: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const payload = form.emailOrUsername.includes('@')
        ? { email: form.emailOrUsername, password: form.password }
        : { username: form.emailOrUsername, password: form.password };

      const res = await fetch('https://api.laviopaperie.com/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Login gagal');

      // Simpan user
      localStorage.setItem('user', JSON.stringify(data.user));
      alert(`Selamat datang, ${data.user.username}`);
      nav('/workspace');
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="camera-results" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form onSubmit={onSubmit} style={{ background: '#fff', padding: 24, borderRadius: 12, width: 360 }}>
        <h2>Login</h2>
        {err && <div style={{ color: '#dc3545', marginBottom: 8 }}>{err}</div>}
        <div style={{ marginBottom: 12 }}>
          <label>Email atau Username</label>
          <input name="emailOrUsername" value={form.emailOrUsername} onChange={onChange} required className="start-button" style={{ width: '100%', padding: 10 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Password</label>
          <input type="password" name="password" value={form.password} onChange={onChange} required className="start-button" style={{ width: '100%', padding: 10 }} />
        </div>
        <button type="submit" className="start-button" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Memproses...' : 'Masuk'}
        </button>
        <div style={{ marginTop: 12, textAlign: 'center' }}>
          Belum punya akun? <Link to="/register">Daftar</Link>
        </div>
      </form>
    </div>
  );
};

export default Login;
